import { useState, useEffect } from 'react'
import styles from "../../../pages/Home/ClientConfig/ClientConfig.module.css"
import * as eventManagementService from '../../../services/eventManagementService'

const MembersuiteConfig = ({
    formData,
    memberSuiteClientConfig,
    setMembersuiteClientConfig,
}) => {

    const handleChange = e => {
        setMembersuiteClientConfig({
            ...memberSuiteClientConfig,
            [e.target.name]: e.target.value,
        })
        //console.log(memberSuiteClientConfig)
    }
	const [error, setError] = useState(null)
    const errorDiv = (error)
        ?
        <ul>
            {Object.entries(error).length > 0 && Object.entries(error) &&
                Object.entries(error).map(([key, value]) => {
                    //console.log("error: " + error)
                    return <div className={value[0] === 'Test Failure' ? styles.errorMSG : styles.successMSG} key={key} >{value}</div>;
                })}
        </ul>
        : '';
    const handleTestConnection = async e => {
        e.preventDefault()
        setError(null)
        var holder = { memberSuiteClientConfig };
        try {
            await eventManagementService.testSetup(holder)
        } catch (err) {
            //console.log(err.message)
			setError(err.internalError);
        }
    }

    const isFormValid = () => {
        return formData.ClientName
            && formData.EventRegistrationSystem
            && formData.Industry
            && formData.Categories.length > 0
            && memberSuiteClientConfig.TenantId
            && memberSuiteClientConfig.Username
            && memberSuiteClientConfig.Password
            && memberSuiteClientConfig.URL
            && memberSuiteClientConfig.EventSQL
            && memberSuiteClientConfig.EventRegistrationSQL
            && memberSuiteClientConfig.SessionSQL
            && memberSuiteClientConfig.SessionRegistrationSQL
            ? true
            : false
    }
	const isTestFormValid = () => {
        return memberSuiteClientConfig.TenantId
            && memberSuiteClientConfig.Username
            && memberSuiteClientConfig.Password
            && memberSuiteClientConfig.URL
            ? true
            : false
    }
    return (
        <>
            <div className={styles.inputContainer}>
                <label htmlFor="TenantId" className={styles.label}>TenantId: </label>
                <input
                    type="number"
                    autoComplete="off"
                    value={memberSuiteClientConfig.TenantId}
                    name="TenantId"
                    onChange={handleChange}
                />
            </div>

            <div className={styles.inputContainer}>
                <label htmlFor="Username" className={styles.label}>Username: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={memberSuiteClientConfig.Username}
                    name="Username"
                    onChange={handleChange}
                />
            </div>
             <div className={styles.inputContainer}>
                <label htmlFor="Password" className={styles.label}>Password: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={memberSuiteClientConfig.Password}
                    name="Password"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="URL" className={styles.label}>URL: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={memberSuiteClientConfig.URL}
                    name="URL"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="EventSQL" className={styles.label}>EventSQL: </label>
                <textarea
                    autoComplete="off"
                    value={memberSuiteClientConfig.EventSQL}
                    name="EventSQL"
                    rows="4"
                    cols="100"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="EventRegistrationSQL" className={styles.label}>EventRegistrationSQL: </label>
                <textarea
                    type="textarea"
                    autoComplete="off"
                    value={memberSuiteClientConfig.EventRegistrationSQL}
                    name="EventRegistrationSQL"
                    rows="4"
                    cols="100"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="SessionSQL" className={styles.label}>SessionSQL: </label>
                <textarea
                    type="textarea"
                    autoComplete="off"
                    value={memberSuiteClientConfig.SessionSQL}
                    name="SessionSQL"
                    rows="4"
                    cols="100"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="SessionRegistrationSQL" className={styles.label}>SessionRegistrationSQL: </label>
                <textarea
                    type="textarea"
                    autoComplete="off"
                    value={memberSuiteClientConfig.SessionRegistrationSQL}
                    name="SessionRegistrationSQL"
                    rows="4"
                    cols="100"
                    onChange={handleChange}
                />
            </div>
			 {errorDiv}
            <div className={styles.inputContainer}>
                <button disabled={!isFormValid()} className={styles.button}>
                    Submit
                </button>
                <button onClick={handleTestConnection} disabled={!isTestFormValid()} className={styles.buttonRight}>
                    Test Connection
                </button>
            </div>
        </>
    );
}

export default MembersuiteConfig;